import { toast } from "react-toastify";

import * as actions from "../api";
import { logoutRequested } from "../users/auth";

const TOAST_COOLDOWN = 5000;
let lastToastTime = 0;

let lastErrorCode;
let theErrorCodeBefore;

const tryToShowToast = (message) => {
    const now = Date.now();
    if (now - lastToastTime > TOAST_COOLDOWN) {
        lastToastTime = now;
        toast.error(message || "Unknown error", {
            position: "top-center",
            autoClose: 5000
        });
    }
}

const handleRequestErrors =
    ({ dispatch, getState }) =>
        next =>
            action => {
                if (action.type !== actions.apiCallFailed.type) {
                    return next(action);
                }

                const { code, message } = action.payload;

                const { isLoggedIn } = getState().users.auth;

                if (code === 401 && isLoggedIn) {
                    tryToShowToast(message || "Access denied");
                    dispatch({ type: logoutRequested.type });// logs out user
                } else if (code === 403) {
                    tryToShowToast(message || "Access denied");
                } else {
                    if (code !== 404 &&
                        (code !== lastErrorCode && code !== theErrorCodeBefore)) {
                        tryToShowToast(message);

                        //T15305 (RTI 08.10.2021) Comparing 2 last codes as in case of server error, 404 and 500 are given in turns
                        lastErrorCode = theErrorCodeBefore && theErrorCodeBefore !== code ? code : lastErrorCode;
                        theErrorCodeBefore = lastErrorCode !== code ? code : theErrorCodeBefore;

                    }
                }
                return next(action);
            };

export default handleRequestErrors;
